<template>
    <div class="checkout-basket-product">
        <a :href="result.detailPage" class="checkout-basket-product__image">
            <DefImg :result="result.picture" />
        </a>
        <div class="checkout-basket-product__description">
            <a :href="result.detailPage" class="checkout-basket-product__name">
                {{ result.name }}
            </a>
            <span class="checkout-basket-product__size" v-if="getActiveSize">
                <span class="checkout-basket-product__title">
                    {{ messages.size + ': ' }}
                </span>
                {{ getActiveSize.displayValue }}
            </span>
        </div>
        <div>
            <div class="checkout-basket-product__count">
                <span class="checkout-basket-product__title">
                    {{ messages.quantity }}
                </span>
                <span class="checkout-basket-product__number">
                    {{ result.count }}
                </span>
            </div>
            <div
                v-if="result.price"
                class="checkout-basket-product__prices"
            >
                <DefSale>
                    {{ result.price.printDiscount }}
                </DefSale>
                <DefPriceOld>
                    {{ result.price.printPriceOld }}
                </DefPriceOld>
                <DefPrice>
                    {{ result.price.printPrice }}
                </DefPrice>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import DefImg from "../../def/DefImg/DefImg";
import DefPrice from "../../def/DefPrice/DefPrice";
import DefPriceOld from "../../def/DefPriceOld/DefPriceOld";
import DefSale from "../../def/DefSale/DefSale";

export default {
    name: 'CheckoutBasketProduct',
    selector: '.checkout-basket-product',
    props: ['result'],
    components: {
        DefImg,
        DefPrice,
        DefPriceOld,
        DefSale,
    },
    computed: {
        ...mapState({
            messages: ({ checkout }) => checkout?.data?.vue?.messages,
        }),
        getActiveSize() {
            return this.result?.propsForCheck?.SIZES?.find(el => el.active);
        },
    }
}
</script>

<style lang="scss" scoped>
.checkout-basket-product{
    display: grid;
    grid-template-columns: 64px 1fr auto;
    grid-column-gap: 8px;
    align-items: center;
    @include point-md{
        grid-template-columns: 88px 1fr auto;
        grid-column-gap: 16px;
    }
    @include point-lg{
        grid-template-columns: 80px 1fr auto;
    }
    &__description{
        display: grid;
        grid-row-gap: 2px;
    }
    &__name{
        font-weight: 500;
        font-size: 14px;
        line-height: 115%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--text-colour-primary);
    }
    &__size{
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        color: #757575;
    }
    &__count{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    &__prices{
        display: grid;
        grid-row-gap: 5px;
    }
}
</style>